import forEach from "lodash/forEach";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { useCallback } from "react";

import { useResponseErrors } from "../helpers/use_response_errors";

type ErrorsGrowlOptions = {
  display?: "firstOne" | "onePerType" | "all";
};

export const useErrorsGrowl = () => {
  const { showGrowl } = useGrowlStoreActions();
  const { getSingleErrorByType, getAllErrorsByType, getFirstError } = useResponseErrors();

  return useCallback(
    (errors: any, { display }: ErrorsGrowlOptions = { display: "onePerType" }) => {
      if (display === "firstOne") {
        const errorMessage = getFirstError(errors);
        errorMessage && showGrowl({ message: errorMessage, kind: "error" });
        return;
      }

      if (display === "onePerType") {
        forEach(getSingleErrorByType(errors), (errorMessage) =>
          showGrowl({ message: errorMessage, kind: "error" })
        );
        return;
      }

      if (display === "all") {
        const allErrors = getAllErrorsByType(errors);
        forEach(allErrors, (errors) =>
          forEach(errors, (errorMessage) => showGrowl({ message: errorMessage, kind: "error" }))
        );
      }
    },
    [getAllErrorsByType, getFirstError, getSingleErrorByType, showGrowl]
  );
};
